import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import PeopleSort from './Sort';

import UpgradePlanButton from '../UpgradePlanButton';

const PeopleHeader = ({ loaded, total }) => {
  const intl = useIntl();

  return (
    <header className="page-header with-upgrade-button">
      <h2 className="page-title">
        <i className="far fa-user-viewfinder" />
        {intl.formatMessage({ defaultMessage: 'People' })}
      </h2>
      <UpgradePlanButton feature="face-recognition" />
      <div className="header-actions">
        {total > 0 && (
          <>
            <PeopleSort />
            <span>
              {intl.formatMessage(
                { defaultMessage: '{loadedPeople} of {totalPeople} {totalPeople, plural, one {person} other {people}}' },
                { loadedPeople: loaded, totalPeople: total },
              )}
            </span>
          </>
        )}
      </div>
    </header>
  );
};

PeopleHeader.propTypes = {
  loaded: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
};

export default PeopleHeader;
